/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from './dashboard'
import questions from './questions'
import games from './games'
import fnfLeague from './fnf-league'
import strips from './strips'
import feedback from './feedback'
import finance from './finance'
import authorTasks from './author-tasks'
import players from './players'
import content from './content'
import dbMovies from './db-movies'
import dbMusic from './db-music'
import generator from './generator'
import packs from './packs'
import moderation from './moderation'
import admin from './admin'

// Плоские секции: заголовок + пункты, без сворачиваемых групп — ничего не спрятано.
// Длинные секции («Игры», «База <Музыка>») поделены подзаголовками на том же
// resource, поэтому деление не влияет на видимость пунктов.
export default [
  ...dashboard,
  ...questions,
  ...games,
  ...fnfLeague,
  ...strips,
  ...feedback,
  ...finance,
  ...authorTasks,
  ...players,
  ...content,
  ...dbMovies,
  ...dbMusic,
  ...generator,
  ...packs,
  ...moderation,
  ...admin,
]
